var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row m-0 blog-preview-badge",
    style: {
      'height': _vm.heightStyle
    },
    on: {
      "click": function () {
        return _vm.activateBlogsNameMenuItem(_vm.id);
      }
    }
  }, [_c('div', {
    staticClass: "col-12 col-lg-4 col-xl-4",
    style: {
      'height': _vm.imageContainerHeight
    }
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.image,
      "alt": _vm.imageDescription
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-8 col-xl-8 pl-lg-0 pl-xl-0",
    class: _vm.paddingTopClass,
    style: {
      'height': _vm.infoContainerHeight
    }
  }, [_c('div', {
    staticClass: "info-area"
  }, [_c('div', {
    staticStyle: {
      "height": "35%"
    }
  }, [_c('h3', {
    staticClass: "limit-lines-2"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "caption limit-lines-4",
    style: {
      'height': _vm.captionHeight
    }
  }, [_vm._v(" " + _vm._s(_vm.caption) + " ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }